module.exports = __webpack_public_path__ + "img/lrg.ad68750c.png";